module.exports = __webpack_public_path__ + "static/img/herostone.54ff09ae.png";